import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { IUserLogin, UserLogin } from '../../models/user';
import { namespace } from 'vuex-class';
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_AUTHORIZE, AUTHORIZATION_SIGN_IN } from '../../store/authorization';
import { Validator } from '../../utils/Validator.util';
import VueRouter from 'vue-router';
import { ActivityStatus } from '../../common/enums';

const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component
class Container extends Vue {
  dtForm: boolean;
  dtPasswordMode: string;
  dtUserInfo: IUserLogin;
  rules: { require: any, email: any };
  /**
   *
   */
  constructor() {
    super();
    this.dtForm = false;
    this.dtUserInfo = new UserLogin({ password: "", email: "" })
    this.dtPasswordMode = "password";

    this.rules = {
      require: (value: string) => !!value || 'Required.',
      email: (value: string) => Validator.IsValidEmail(value) || 'l\'email n\'est pas valide',
    }
  }
  get lblSetting() {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/login-form').default,
    }
  }

  @AuthorizationStore.Getter signInPayload: {
    error: any,
    activityStatus: ActivityStatus
  }


  @AuthorizationStore.Action(AUTHORIZATION_SIGN_IN)
  storeAuthorization: (payload: { router: VueRouter, userInfo: IUserLogin }) => Promise<void>;


  get isLoading(): boolean {
    return this.signInPayload.activityStatus === ActivityStatus.Loading
  }
  get loginError(): any {
    return this.signInPayload.error;
  }


  _clearTimeout: any
  handleAuthorize() {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (!(this.$refs['loginFormRef'] as any).validate()) return;
      this.storeAuthorization({ router: this.$router, userInfo: this.dtUserInfo })
    }, 300)

  }


  handleRedirect(path: string) {
    this.$router.push(path);
  }

  handleShowPassword() {
    this.dtPasswordMode = this.dtPasswordMode === 'password' ? 'text' : 'password'
  }
}

export default Container;


// WEBPACK FOOTER //
// ./src/containers/login/index.ts